module.exports = __webpack_public_path__ + "img/CtrlRoom_sun_3.450ffa1d.png";